export default __webpack_public_path__ + "/images/spiral-nebula.jpg";